import React from 'react';
import { Link } from 'react-router-dom';

const apps = [
	{ path: '/dashboard/v4', icon: 'solar:chart-line-duotone', title: 'Dashboard' },
	{ path: '/ai/chat', icon: 'solar:soundwave-line-duotone', title: 'AI Studio' },
	{ path: '/profile', icon: 'solar:inbox-line-line-duotone', title: 'Profile' },
	{ path: '/email/inbox', icon: 'solar:user-line-duotone', title: 'Inbox' },
	{ path: '/pos/customer-order', icon: 'solar:bag-smile-line-duotone', title: 'Pos System', target: '_blank' },
	{ path: '/calendar', icon: 'solar:calendar-line-duotone', title: 'Calendar' },
	{ path: '/helper', icon: 'solar:help-line-duotone', title: 'Helper' },
	{ path: '/settings', icon: 'solar:settings-line-duotone', title: 'Settings' },
	{ path: '/widget', icon: 'solar:cpu-bolt-line-duotone', title: 'Widgets' }
];

function DropdownApps() {
	return (
		<div className="menu-item dropdown">
			<a href="#/" data-bs-toggle="dropdown" className="menu-link" aria-label="Open applications">
				<iconify-icon icon="solar:widget-bold-duotone"></iconify-icon>
			</a>
			<div className="dropdown-menu dropdown-menu-end p-2 w-300px text-center">
				<div className="row g-2">
					{apps.map((app) => (
						<div className="col-4" key={app.path}>
								<Link to={app.path} target={app.target} className="dropdown-item text-decoration-none p-2 rounded-2">
								<div className="my-1"><iconify-icon icon={app.icon} className="fs-2 d-block"></iconify-icon></div>
								<div className="fw-semibold small">{app.title}</div>
							</Link>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}

export default DropdownApps;
